import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo, useState } from "preact/hooks"
import { productImagePlaceholder, addToCart, injectProductScripts } from "../helpers"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    //const [itemScript, setItemScript] = useState()
    const limitedEdition = useMemo(() => product?.tags1?.find(tag => tag.includes('limited edition')), [])
    const sizeBadge = useMemo(() => {
        return product?.tags1
          ?.filter(tag => tag.includes('Size_') && !tag.includes('Pack Size'))
          ?.find(Boolean)
          ?.split("_")
          .pop();
      }, [product?.tags1]);
      
    const productHandle = useMemo(() => product?.url?.split("/")?.pop(), [])

    injectProductScripts(productHandle, product.productId).then((data) => {
        data = JSON.parse(data.innerHTML);

        var itm = new window.ProductGridItem({
            $el:  jQuery(`.ns-product-${product.productId}`),
            id: 'nosto-serp-template',
            product: data,
            lazy: true
        })

        //console.log(itm)
    })

    
    

    return (
        <SerpElement
            as="li"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class={`ns-product ns-product-${product.productId} ns-border-box ns-clickable ns-text-undecorated ns-color-inherit productgrid--item imagestyle--medium show-actions--mobile`}
        >
            {/* {productHandle && injectProductScripts(product)} */}
            <article class={`productitem ${product.onDiscount ? 'productitem--sale' : ''}`}>
                {limitedEdition && <img class="badge--limitededition" src="https://cdn.shopify.com/s/files/1/0043/9258/3217/files/Limited_Edition_Badge_200x200_crop_center.png" />}
                
                <a class="productitem--image-link" href={product.url} tabindex="-1" data-product-page-link="true">
                    <figure class="productitem--image" data-product-item-image="true">
                        <img
                            class="productitem--image-primary"
                            src={product.imageUrl ?? productImagePlaceholder}
                            alt={product.name}
                            title={product.name}
                            loading="lazy"
                        />
                        {product.availability == "OutOfStock" && <span class="productitem--badge badge--soldout">Sold Out</span>}
                        {product.onDiscount & product.availability != "OutOfStock" && <span class="productitem--badge badge--sale">Sale</span>}
                        {sizeBadge && sizeBadge != "700ml" && sizeBadge != "750ml" && <span class="productitem--badge badge--size ns-size-badge">{sizeBadge}</span>}

                    </figure>
                </a>
                <div class="productitem--info">
                    <h2 class="productitem--title">
                        <a href={product.url} data-product-page-link="true">{product.name}</a>
                    </h2>
                    <div class="productitem--price">
                        <div class="productitem--price">
                            <div class={`price--compare-at ${product.onDiscount ? 'visible' : ''}`} data-price-compare-at="true">
                                <span class="visually-hidden">Original Price</span>
                                {product.onDiscount ? <span class="money">{format(product.listPrice)}</span> : <span class="money">$0.00</span>}
                            </div>
                            <div class="price--main" data-price="true">
                                <span class="money">{format(product.price)}</span>
                            </div>
                            <div class=" product__unit-price hidden " data-unit-price="true">
                                <span class="product__total-quantity" data-total-quantity="true"></span> 
                                |<span class="product__unit-price-amount money" data-unit-price-amount="true"></span> 
                                / <span class="product__unit-price-measure" data-unit-price-measure="true"></span>
                            </div>
                        </div>
                    </div>
                    <div class="productitem--description">
                        <a class="productitem--link" data-product-page-link="true" href={product.url}>View full details</a>
                    </div>
                </div>
                <div class="productitem--actions" data-product-actions="true" data-product-actions-id={product.productId}>
                    <div class="productitem--listview-price">
                        <div class="productitem--price">
                            <div class="price--compare-at" data-price-compare-at="true">
                                <span class="visually-hidden">Original Price</span>
                                <span class="money">$0.00</span>
                            </div>
                            <div class="price--main" data-price="true">
                                <span class="money">{format(product.price)}</span>
                            </div>
                            <div class=" product__unit-price hidden " data-unit-price="true">
                                <span class="product__total-quantity" data-total-quantity="true"></span>
                                | <span class="product__unit-price-amount money" data-unit-price-amount="true"></span> 
                                / <span class="product__unit-price-measure" data-unit-price-measure="true"></span>
                            </div>
                        </div>
                    </div>
                    <div class=" productitem--action quickshop-button">
                        <button class="productitem--action-trigger productitem--action-atc button-primary" type="button" aria-label="Add to cart" data-quick-buy="true" onClick={(e) => addToCart(e, product.skus[0]?.id)} data-variant-id={product.skus[0]?.id}>
                            <span class="atc-button--text">Add to cart</span>
                            <span class="atc-button--icon">
                                <svg class="icon-spinner " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                    <title>Spinner icon</title>
                                    <circle opacity="0.29" cx="13" cy="13" r="11" stroke="currentColor" stroke-width="2"></circle>
                                    <path d="M24 13C24 19.0751 19.0751 24 13 24" stroke="currentColor" stroke-width="2"></path>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div class=" productitem--action atc--button ">
                        <button class="productitem--action-trigger productitem--action-qs button-secondary" data-quickshop-trigger="full" type="button">Quick shop</button>
                    </div>
                </div>
            </article>
            <div class="productitem-quickshop" data-product-quickshop={product.productId} data-product-quickshop-url={product.url} data-product-quickshop-hash={`${product.productId}-collection`}></div>
        </SerpElement>
    )
}
